import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { BookOpen } from 'lucide-react';
import { Button } from '../ui/button';
import { Progress } from '../ui/progress';

export function EnrolledCoursesCard({ courses, loading }) {
  const { t } = useLanguage();

  return (
    <div className="bg-[#141417] border border-[#27272A] rounded-md p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold text-white" style={{ fontFamily: 'Chivo, sans-serif' }}>
          {t('dashboard.yourCourses')}
        </h2>
        <Link to="/dashboard/courses">
          <Button variant="ghost" className="text-[#007AFF] text-sm">{t('dashboard.viewAll')}</Button>
        </Link>
      </div>

      {renderContent()}
    </div>
  );

  function renderContent() {
    if (loading) {
      return (
        <div className="space-y-4">
          {[1, 2, 3].map(i => (
            <div key={i} className="skeleton h-20 rounded-md"></div>
          ))}
        </div>
      );
    }
    if (courses.length > 0) {
      return (
        <div className="space-y-4">
          {courses.slice(0, 3).map(course => (
            <div key={course.id} className="flex items-center gap-4 p-4 bg-[#09090B] border border-[#27272A] rounded-md">
              <img src={course.image_url} alt={course.title} className="w-16 h-16 object-cover rounded-sm" />
              <div className="flex-1">
                <h3 className="text-white font-medium">{course.title}</h3>
                <div className="flex items-center gap-2 mt-1">
                  <Progress value={course.progress_percent || 0} className="h-1 flex-1" />
                  <span className="text-[#007AFF] text-xs font-mono">{course.progress_percent || 0}%</span>
                </div>
              </div>
              <Link to={`/dashboard/courses/${course.id}`}>
                <Button variant="ghost" className="text-[#007AFF]" data-testid={`continue-${course.id}`}>
                  {t('dashboard.continue')}
                </Button>
              </Link>
            </div>
          ))}
        </div>
      );
    }
    return (
      <div className="text-center py-8">
        <BookOpen className="w-12 h-12 text-[#71717A] mx-auto mb-4" />
        <p className="text-[#71717A] mb-4">{t('dashboard.noCoursesYet')}</p>
        <Link to="/#courses">
          <Button className="btn-primary" data-testid="browse-courses-btn">{t('dashboard.browseCourses')}</Button>
        </Link>
      </div>
    );
  }
}
